import styled from 'styled-components'

import { COLORS } from 'COLORS'

export const NavbarWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  display: flex;
  justify-content: space-between;
  background-color: ${COLORS.white};
  flex-wrap: wrap;
  z-index: 90;
  align-items: stretch;
  box-shadow: 0 1px 0 0 ${COLORS.coolGrey300};
  height: 48px;
`
